var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-top-menu",class:{ 'd-block': _vm.appOptions.appTopMenuMobileToggled },attrs:{"id":"top-menu"}},[_c('top-menu-nav')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }